<template>
  <div class="flex-col page">
    <div class="flex-row justify-between self-stretch group">
      <div class="flex-row self-start group_2">
        <span class="font text" @click="$router.push('/shouye')">视频</span>
        <span class="ml-68 font text_2">专题</span>
      </div>
      <img
        class="image"
        src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=7f83a0edaf88e69e747431d44a163903.png"
      />
    </div>
    <div class="flex-col self-stretch group_3">
      <span class="self-start font_2 text_3">重磅消息</span>
      <div class="mt-16 flex-row group_4 horiz-list">
        <div class="flex-col section horiz-list-item">
          <div class="flex-col justify-start self-stretch relative section_2">
            <div class="shrink-0 section_3"></div>
            <div class="flex-col justify-start items-center text-wrapper pos"><span class="font_3">行业资讯</span></div>
          </div>
          <span class="mt-4 self-center font_4 text_4">重磅！2024年保险新规要来了</span>
        </div>
        <div class="flex-col section horiz-list-item ml-19">
          <div class="flex-col justify-start self-stretch relative section_4">
            <div class="shrink-0 section_5"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_2">
              <span class="font_3">行业资讯</span>
            </div>
          </div>
          <span class="mt-4 self-center font_4 text_4">重磅解读：2024重疾险新规三大变革</span>
        </div>
        <div class="flex-col section horiz-list-item ml-19">
          <div class="flex-col justify-start self-stretch relative section_6">
            <div class="shrink-0 section_7"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_3">
              <span class="font_3">行业资讯</span>
            </div>
          </div>
          <span class="mt-4 self-center font_4 text_5">重疾险定义修订：158项vs180项对比</span>
        </div>
        <div class="flex-col section section_8 ml-19">
          <div class="flex-col justify-start self-stretch relative section_9">
            <div class="shrink-0 section_10"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_4">
              <span class="font_3">行业资讯</span>
            </div>
          </div>
          <span class="mt-4 self-center font_4 text_6">惠民保扩容：十城市最新试点政策分析</span>
        </div>
      </div>
    </div>
    <div class="flex-col self-stretch group_3">
      <span class="self-start font_2 text_7">学平险</span>
      <div class="mt-16 flex-row group_4 horiz-list">
        <div class="flex-col section horiz-list-item">
          <div class="flex-col justify-start self-stretch relative section_11">
            <div class="shrink-0 section_12"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_5">
              <span class="font_3">行业资讯</span>
            </div>
          </div>
          <span class="mt-4 self-center font_4 text_11">最新：2024年学平险保障范围全面扩大</span>
        </div>
        <div class="flex-col section horiz-list-item ml-19">
          <div class="flex-col justify-start self-stretch relative section_13">
            <div class="shrink-0 section_14"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_6">
              <span class="font_3 text_8">案例分享</span>
            </div>
          </div>
          <span class="mt-4 self-center font_4 text_6">体育课意外受伤，学平险赔付8万全过程</span>
        </div>
        <div class="flex-col section horiz-list-item ml-19">
          <div class="flex-col justify-start self-stretch relative section_13">
            <div class="shrink-0 section_14"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_7">
              <span class="font_3 text_9">保险科普</span>
            </div>
          </div>
          <span class="mt-4 self-center font_4 text_6">学平险vs儿童意外险，差别就差在这</span>
        </div>
        <div class="flex-col section horiz-list-item ml-19">
          <div class="flex-col justify-start self-stretch relative section_13">
            <div class="shrink-0 section_14"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_8">
              <span class="font_3 text_10">产品测评</span>
            </div>
          </div>
          <span class="mt-4 self-center font_4 text_12">15家学平险产品横向测评，这3家最值</span>
        </div>
      </div>
    </div>
    <div class="flex-col items-start self-stretch group_5">
      <span class="font_2 text_13">分红险</span>
      <div class="mt-16 flex-row equal-division">
        <div class="flex-col section_15 equal-division-item">
          <div class="flex-col justify-start self-stretch relative section_16">
            <div class="shrink-0 section_17"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_9">
              <span class="font_3 text_14">产品测评</span>
            </div>
          </div>
          <span class="mt-4 self-center font_4 text_11">20年分红险老产品VS新产品全面对比</span>
        </div>
        <div class="flex-col section_15 equal-division-item ml-19">
          <div class="flex-col justify-start self-stretch relative section_18">
            <div class="shrink-0 section_19"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_10">
              <span class="font_3 text_15">案例分享</span>
            </div>
          </div>
          <span class="mt-4 self-center font_4 text_17">老保单翻倍！20年分红险回报实战分析</span>
        </div>
        <div class="flex-col section_15 equal-division-item ml-19">
          <div class="flex-col justify-start self-stretch relative section_20">
            <div class="shrink-0 section_21"></div>
            <div class="flex-col justify-start items-center text-wrapper pos_11">
              <span class="font_3 text_16">销售话术</span>
            </div>
          </div>
          <span class="mt-4 self-center font_4 text_4">孩子刚出生，给TA最好的人生礼物是什么</span>
        </div>
      </div>

      <div class="flex-row self-stretch relative bottom">
        <div class="section_10"></div>
        <div class="flex-col shrink-0 section_12 pos_6">
          <div class="flex-row justify-between">
            <img
              class="image_4"
              src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=9f5112687f44aaca4f0ffc0181e0d62d.png"
            />
            <img
              @click="$router.push('/xiangce')"
              class="image_4"
              src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=583c5fb06c92fb3306dfd6d4a531c8b8.png"
            />
            <img
              @click="$router.push('/wode')"
              class="image_4"
              src="https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=0a46c269bca69f2c4e3e6be4818af774.png"
            />
          </div>
          <div class="mt-4 flex-row justify-between">
            <span class="font_5 text_13">主页</span>
            <span class="font_5">相册</span>
            <span class="font_5">我的</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: {},
    props: {},
    data() {
      return {};
    },

    methods: {},
  };
</script>

<style scoped lang="less">
  .ml-19 {
    margin-left: 19px;
  }
  .page {
    padding: 37px 0 30px 20px;
    background-color: rgb(17, 17, 17);
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    .group {
      padding: 0 11px;
      .group_2 {
        margin-left: 86px;
        .font {
          font-size: 18px;
          font-family: Barlow;
          line-height: 16.5px;
        }
        .text {
          color: rgba(255, 255, 255, 0.5);
        }
        .text_2 {
          color: rgb(85, 239, 227);
          font-weight: 600;
          line-height: 17px;
        }
      }
      .image {
        width: 26px;
        height: 26px;
      }
    }
    .group_3 {
      margin-top: 24px;
      overflow-x: hidden;
      .text_3 {
        line-height: 15px;
      }
      .group_4 {
        align-self: stretch;
        .section {
          flex-shrink: 0;
          .section_2 {
            border-radius: 9.5px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=5262089c3ecd1d0bf6d72070778be2be.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .section_3 {
              border-radius: 9.5px;
              overflow: hidden;
              background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=5262089c3ecd1d0bf6d72070778be2be.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 123px;
            }
            .pos {
              position: absolute;
              left: 7px;
              top: 101px;
            }
          }
          .section_4 {
            border-radius: 9.5px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=fa82478d78289b50d8cff67cfe71bd12.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .section_5 {
              border-radius: 9.5px;
              overflow: hidden;
              background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=fa82478d78289b50d8cff67cfe71bd12.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 123px;
            }
            .pos_2 {
              position: absolute;
              left: 7px;
              top: 101px;
            }
          }
          .section_6 {
            border-radius: 9.5px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=6019c1e32faabe714ea25d89e14bde61.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .section_7 {
              border-radius: 9.5px;
              overflow: hidden;
              background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=6019c1e32faabe714ea25d89e14bde61.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 123px;
            }
            .pos_3 {
              position: absolute;
              left: 7px;
              top: 101px;
            }
          }
          .text_5 {
            width: 90px;
          }
          .section_9 {
            border-radius: 9.5px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=e6f8655ab3ddaa0205246f0014bccaf0.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .section_10 {
              border-radius: 9.5px;
              overflow: hidden;
              background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=e6f8655ab3ddaa0205246f0014bccaf0.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 123px;
            }
            .pos_4 {
              position: absolute;
              left: 7px;
              top: 101px;
            }
          }
          .text_6 {
            width: 86px;
          }
          .section_11 {
            border-radius: 9.5px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=78cca0b5ea404b1b02e2fe957125babe.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .section_12 {
              border-radius: 9.5px;
              overflow: hidden;
              background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=78cca0b5ea404b1b02e2fe957125babe.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 123px;
            }
            .pos_5 {
              position: absolute;
              left: 7px;
              top: 101px;
            }
          }
          .section_13 {
            border-radius: 9.5px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=bcda6b27bd58759b0640ecc65e994248.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .section_14 {
              border-radius: 9.5px;
              overflow: hidden;
              background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=bcda6b27bd58759b0640ecc65e994248.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 123px;
            }
            .pos_6 {
              position: absolute;
              left: 7px;
              top: 101px;
            }
            .pos_7 {
              position: absolute;
              left: 7px;
              top: 101px;
            }
            .pos_8 {
              position: absolute;
              left: 7px;
              top: 101px;
            }
          }
          .text_12 {
            width: 85px;
          }
        }
        .horiz-list-item {
          padding-bottom: 12px;
          background-color: rgba(255, 255, 255, 0.05);
          border-radius: 9.5px;
          overflow: hidden;
          width: 98px;
          height: 166px;
        }
        .section_8 {
          padding-bottom: 12px;
          background-color: rgba(255, 255, 255, 0.05);
          border-radius: 9.5px 0 0 9.5px;
          overflow: hidden;
          width: 98px;
          height: 166px;
        }
      }
      .horiz-list {
        overflow-x: auto;
      }
      .text_7 {
        line-height: 14.5px;
      }
    }
    .group_5 {
      margin-top: 24px;
      .text_13 {
        line-height: 15px;
      }
      .equal-division {
        width: 332px;
        .section_15 {
          flex: 1 1 98px;
          .section_16 {
            border-radius: 9.5px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=189264a3179951a3fe73e0fb35b8ae3b.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .section_17 {
              border-radius: 9.5px;
              overflow: hidden;
              background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=189264a3179951a3fe73e0fb35b8ae3b.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 123px;
            }
            .pos_9 {
              position: absolute;
              left: 7px;
              top: 101px;
            }
          }
          .section_18 {
            border-radius: 9.5px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=d82e54ffd80fa95dc2ddf2f907286971.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .section_19 {
              border-radius: 9.5px;
              overflow: hidden;
              background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=d82e54ffd80fa95dc2ddf2f907286971.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 123px;
            }
            .pos_10 {
              position: absolute;
              left: 7px;
              top: 101px;
            }
          }
          .text_17 {
            width: 87px;
          }
          .section_20 {
            border-radius: 9.5px;
            overflow: hidden;
            background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=afeb1b1a25bac4b33f03af29c838ff54.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            .section_21 {
              border-radius: 9.5px;
              overflow: hidden;
              background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=afeb1b1a25bac4b33f03af29c838ff54.png');
              background-size: 100% 100%;
              background-repeat: no-repeat;
              height: 123px;
            }
            .pos_11 {
              position: absolute;
              left: 7px;
              top: 101px;
            }
          }
        }
        .equal-division-item {
          padding-bottom: 12px;
          background-color: rgba(255, 255, 255, 0.05);
          border-radius: 9.5px;
          overflow: hidden;
          height: 166px;
        }
      }
    }
    .font_2 {
      font-size: 16px;
      font-family: Barlow;
      line-height: 14.5px;
      color: rgba(255, 255, 255, 0.8);
    }
    .text-wrapper {
      padding: 2px 0 6px;
      background-color: rgb(85, 239, 227);
      border-radius: 5px;
      width: 38.5px;
      .font_3 {
        font-size: 7px;
        font-family: Barlow;
        line-height: 6px;
        color: rgb(17, 17, 17);
        margin-top: 3px;
      }
      .text_8 {
        line-height: 6.5px;
      }
      .text_9 {
        line-height: 6.5px;
      }
      .text_10 {
        line-height: 6.5px;
      }
      .text_14 {
        line-height: 6.5px;
      }
      .text_15 {
        line-height: 6.5px;
      }
      .text_16 {
        line-height: 6.5px;
      }
    }
    .font_4 {
      font-size: 9.5px;
      font-family: Barlow;
      line-height: 14.5px;
      color: rgb(255, 255, 255);
    }
    .text_11 {
      width: 89px;
    }
    .text_4 {
      width: 88px;
    }
    .equal-division_2 {
      position: relative;
      align-self: center;
      margin-top: 30px;
      .group_6 {
        position: absolute;
        left: 5px;
        top: 50%;
        transform: translateY(-50%);
        .text_18 {
          color: rgb(46, 5, 5);
          font-size: 10px;
          line-height: 9px;
        }
      }
      .equal-division-item_2 {
        padding: 4px 0;
        width: 92.5px;
        .text_19 {
          font-size: 10px;
        }
      }
      .image_2 {
        width: 25px;
        height: 25px;
      }
      .font_5 {
        font-size: 9.5px;
        font-family: Nunito;
        line-height: 9px;
        color: rgb(166, 166, 166);
      }
      .group_7 {
        position: absolute;
        right: 6.5px;
        top: 50%;
        transform: translateY(-50%);
        .text_20 {
          font-size: 10px;
        }
      }
    }

    .bottom {
      position: fixed;
      bottom: -76px;
      margin-left: 4px;
      .section_10 {
        flex: 1 1 163px;
        border-radius: 16px;
        overflow: hidden;
        height: 204px;
      }
      .section_11 {
        margin-left: 16px;
        margin-right: 20px;
        flex: 1 1 163px;
        background-color: rgba(255, 255, 255, 0.05);
        border-radius: 16px 16px 0 0;
        overflow: hidden;
        height: 204px;
        .image-wrapper {
          border-radius: 16px;
          overflow: hidden;
          background-image: url('https://ide.code.fun/api/image?token=67ad6bcedefdb10011149ee4&name=8d77d3e05f086dca95b84a4b56e9e0de.png');
          background-position: 0% 0%;
          background-size: 100%, 100%;
          background-repeat: no-repeat;
          .image_3 {
            width: 162px;
            height: 204px;
          }
        }
      }
      .image_2 {
        border-radius: 16px;
        overflow: hidden;
        background-color: rgba(255, 255, 255, 0.05);
        width: 163px;
        height: 204px;
      }
      .pos_5 {
        position: absolute;
        left: 0;
        bottom: 0;
      }
      .section_12 {
        padding: 8px 40px 12px;
        background-color: rgb(255, 255, 255);
        border-radius: 32px;
        filter: drop-shadow(-2px 4px 2px #8c8c8c26);
        width: 289px;
        .image_4 {
          width: 24px;
          height: 24px;
        }
        .font_5 {
          font-size: 10px;
          font-family: Nunito;
          line-height: 9px;
          color: rgb(166, 166, 166);
        }
        .text_13 {
          color: rgb(46, 5, 5);
          line-height: 9px;
        }
      }
      .pos_6 {
        position: absolute;
        left: 26.5px;
        top: 41px;
      }
    }
    .section_22 {
      padding: 2px 6px 8px;
      background-color: rgb(255, 255, 255);
      border-radius: 32px;
      filter: drop-shadow(-2px 4px 2px #8c8c8c26);
      width: 289px;
    }
  }
</style>
